import { ComponentHeader, StyledStaticPage, StyledTermPage } from "@components";
import { useTranslation } from "react-i18next";

export const PageTerms = () => {
  const { t } = useTranslation();
  return (
    <>
      <ComponentHeader title={t("page.terms_and_conditions")} />
      <StyledTermPage>
        <p>Terms and Conditions</p>

        <p>
          The following information outlines the terms and conditions governing the use of this
          Portal (referred to as "the Portal") by health facilities contracted with Population
          Services International Myanmar (PSI). By accessing and using the Portal, you agree to be
          bound by these terms and conditions. If you do not agree with any part of these terms and
          conditions, please refrain from using the Portal.
        </p>
        <ul>
          <li>
            Services Provided:
            <ul>
              <li>
                The Portal facilitates the provision of coupons to eligible clients, as determined
                by Population Services International Myanmar (PSI).
              </li>
              <li>
                The coupons provided through the Portal are subject to availability and may be
                limited in quantity.
              </li>
            </ul>
          </li>
          <li>
            Eligibility:
            <ul>
              <li>
                The health facility must meet the criteria and requirements set by PSI to
                participate in the Programs.
              </li>
              <li>
                The decision to approve or reject a users’ application to the Portal is at the sole
                discretion of PSI.
              </li>
            </ul>
          </li>
          <li>
            Responsibilities:
            <ul>
              <li>
                The health facility must comply with all applicable laws, regulations, and ethical
                guidelines in the provision of services through the Portal.
              </li>
              <li>
                The health facility must maintain the confidentiality and privacy of the clients'
                personal information obtained through the Portal and the Program.
              </li>
              <li>
                The health facility is responsible for verifying the validity and authenticity of
                coupons presented by clients and must adhere to the guidelines provided by PSI.
              </li>
            </ul>
          </li>
          <li>
            Limitation of Liability:
            <ul>
              <li>
                PSI and the Portal administrators are not liable for any direct, indirect,
                incidental, consequential, or punitive damages arising from the use of the Portal.
              </li>
              <li>
                PSI and the Portal administrators do not guarantee the availability, accuracy, or
                completeness of the coupons provided through the Portal.
              </li>
              <li>
                The health facility assumes all risks associated with the use of the Portal and
                provision of services.
              </li>
            </ul>
          </li>
          <li>
            Termination:
            <ul>
              <li>
                PSI reserve the right to terminate or suspend access to the Portal by the health
                facility at any time, without prior notice, if they violate these terms and
                conditions or fail to meet the requirements set by PSI.
              </li>
              <li>
                Please carefully review and understand these terms and conditions before using the
                Portal. Your continued use of the Portal indicates your acceptance of these terms
                and conditions. These terms and conditions may be subject to change without prior
                notice, and it is recommended that you review them periodically for any updates. Any
                disputes arising from the use of the Portal shall be subject to the exclusive
                jurisdiction of PSI.
              </li>
            </ul>
          </li>
        </ul>
      </StyledTermPage>
    </>
  );
};
